import defaultWebFonts from './webfonts'
import { FORM_BUTTON_ALIGN_OPTIONS } from '@client/components/blocks/Form/constants'

export const ITEM_TYPE_MAIL = 'MAIL'
export const ITEM_TYPE_RESPONDER = 'RESPONDER'
export const ITEM_TYPE_CONFIRMATION_MAIL = 'CONFIRMATION_MAIL'
export const ITEM_TYPE_PAGE = 'PAGE'
export const ITEM_TYPE_FORM = 'FORM'
export const ITEM_TYPE_LANDING_PAGE = 'LANDING_PAGE'
export const ITEM_TYPE_LANDING_PAGE_SUCCESS = 'LANDING_PAGE_SUCCESS'
export const ITEM_TYPE_SURVEY = 'SURVEYS_SURVEY'
export const ITEM_TYPE_SURVEY_THANK_YOU = 'SURVEYS_THANK_YOU'

export const ITEM_TYPE_FORM_SUBTYPE_SUCCESS = 'FORM_SUBTYPE_SUCCESS'

export const WIZARD_TYPE_FORM = 'FORM'
export const WIZARD_TYPE_PAGE = 'PAGE'
export const WIZARD_TYPE_SURVEY = 'SURVEY'

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', name: 'font.weight.normal' },
  { value: 'bold', name: 'font.weight.bold' },
]

export const FORM_LAYOUT_SHADOW_OPTIONS = [
  {
    value: 'none',
    name: 'jsforms.tabdesign.shadow.option.none',
    shadowValue: 'none',
  },
  {
    value: 'small',
    name: 'jsforms.tabdesign.shadow.option.small',
    shadowValue: '0 5px 10px rgba(0, 0, 0, 0.2)',
  },
  {
    value: 'large',
    name: 'jsforms.tabdesign.shadow.option.large',
    shadowValue: '0 5px 30px rgba(0, 0, 0, 0.2)',
  },
]

export const FORM_SLIDE_IN_LAYOUT_SHADOW_OPTIONS = [
  {
    value: 'none',
    name: 'jsforms.tabdesign.shadow.option.none',
    shadowValue: 'none',
  },
  {
    value: 'small',
    name: 'jsforms.tabdesign.shadow.option.small',
    shadowValue: '0 5px 10px rgba(0, 0, 0, 0.2)',
  },
  {
    value: 'large',
    name: 'jsforms.tabdesign.shadow.option.large',
    shadowValue: '0 5px 10px rgba(0, 0, 0, 0.2)',
  },
]

export const webFonts = defaultWebFonts

export const webSafeFonts = [
  { disabled: false, value: 'Arial, sans-serif', name: 'Arial' },
  { disabled: false, value: 'Trebuchet MS, sans-serif', name: 'Trebuchet MS' },
  { disabled: false, value: 'Verdana, sans-serif', name: 'Verdana' },
  { disabled: false, value: 'Georgia, serif', name: 'Georgia' },
  { disabled: false, value: 'Times New Roman, serif', name: 'Times New Roman' },
  { disabled: false, value: 'Courier, monospace', name: 'Courier' },
]

export const fontFamilies = [
  ...webSafeFonts,
  { disabled: true, value: 'null', name: '–– Web fonts ––' },
  ...webFonts,
]

export const defaultSettings = {
  backgroundColor: '#E1E8ED',
  contentColor: '#ffffff',
  themeColor: '#000000',

  headings_fontFamily: fontFamilies[0].value,
  headings_h1FontSize: '28',
  headings_color: '#111111',
  headings_lineHeight: '1.3',
  headings_fontWeight: FONT_WEIGHT_OPTIONS[1].value,

  normalText_fontFamily: fontFamilies[0].value,
  normalText_color: '#111111',
  normalText_fontSize: '14',
  normalText_lineHeight: '1.5',

  link_color: '#3d7ba4',

  divider_style: 'solid',
  divider_height: '4',
  divider_color: '#dddddd',

  button_text: 'blocks.button.default.text',
  button_url: '',
  button_width: '220',
  button_height: '40',
  button_fontSize: '14',
  button_borderRadius: '3',
  button_backgroundColor: '#444444',
  button_textColor: '#ffffff',
  button_fontWeight: FONT_WEIGHT_OPTIONS[1].value,
  button_align: 'center',
  button_simple_align: FORM_BUTTON_ALIGN_OPTIONS[1].value,

  button_borderStyle: 'solid',
  button_borderColor: '#444444',
  button_borderWidth: '0',

  section_borderStyle: 'none',
  section_borderColor: '#444444',
  section_borderWidth: '0',
}

export const defaultSettingsByType = {
  [ITEM_TYPE_FORM]: {
    backgroundColor: '#00000066',

    popup_borderRadius: '8',

    popup_hasShowDelay: false,
    popup_hasShowOnExit: false,
    popup_showDelay: '0',
  },
  [ITEM_TYPE_SURVEY]: {
    button_simple_align: FORM_BUTTON_ALIGN_OPTIONS[3].value,
  }
}

export const defaultSettingsByFormType = {
  popup: {
    popup_width: '700',
    popup_width_alternate: '550',
    popup_shadow: FORM_LAYOUT_SHADOW_OPTIONS[0].value,
  },
  slide_in: {
    popup_width: '600',
    popup_width_alternate: '450',
    popup_shadow: FORM_SLIDE_IN_LAYOUT_SHADOW_OPTIONS[0].value,
  }
}

export const lineHeight = [
  { value: '1', name: 'Single' },
  { value: '1.1', name: '1.1' },
  { value: '1.2', name: '1.2' },
  { value: '1.3', name: '1.3' },
  { value: '1.4', name: '1.4' },
  { value: '1.5', name: '1.5' },
  { value: '1.6', name: '1.6' },
  { value: '1.7', name: '1.7' },
  { value: '1.8', name: '1.8' },
  { value: '1.9', name: '1.9' },
  { value: '2', name: 'Double' },
]

export { DIVIDER_STYLES } from '@client/components/blocks/Divider/constants'

export const BUTTON_BORDER_STYLES = [
  { value: 'none', name: 'button.border.style.none' },
  { value: 'solid', name: 'button.border.style.solid' },
  { value: 'dashed', name: 'button.border.style.dashed' },
  { value: 'dotted', name: 'button.border.style.dotted' }
]

export const SECTION_BORDER_STYLES = [
  { value: 'top', name: 'section.border.style.top' },
  { value: 'right', name: 'section.border.style.right' },
  { value: 'bottom', name: 'section.border.style.bottom' },
  { value: 'left', name: 'section.border.style.left' }
]

export const SECTION_BORDER_RADIUS_STYLES = [
  { value: 'topLeft', name: 'section.borderRadius.style.topLeft' },
  { value: 'topRight', name: 'section.borderRadius.style.topRight' },
  { value: 'bottomLeft', name: 'section.borderRadius.style.bottomRight' },
  { value: 'bottomRight', name: 'section.borderRadius.style.bottomLeft' }
]

export const SECTION_BORDER_STYLES_VALUES = SECTION_BORDER_STYLES.map((i) => i.value)
export const SECTION_BORDER_RADIUS_STYLES_VALUES = SECTION_BORDER_RADIUS_STYLES.map((i) => i.value)

export const FORMS_STEP_INDEX_FORM = 0
export const FORMS_STEP_INDEX_FORM_SUCCESS = 1
export const FORMS_STEP_INDEX_MAIL = 2
export const FORMS_STEP_INDEX_PAGE = 3

export const PAGES_STEP_INDEX_PAGE = 0
export const PAGES_STEP_INDEX_PAGE_SUCCESS = 1
export const PAGES_STEP_INDEX_MAIL = 2
export const PAGES_STEP_INDEX_CONFIRMATION_PAGE = 3

export const SURVEYS_STEP_INDEX_SURVEY = 0
export const SURVEYS_STEP_INDEX_THANK_YOU = 1
